// Formats: '%,n', '$,n', '$x,n', 'f,n', 'i,n'
// operations: 'last(a)', prod(a,b), ratio(a,b)
export default {
  'tv': {
    '***': {
      '***': [
        {
          metric: 100,
          inHeader: true,
          label: 'Ad Effect Score',
          rowType: 'demphasized',
          dataFormat: '.,0',
          reverseStat: false,
          minSampleSize: 0
        },
        {
          label: 'IN-MARKET PERFORMANCE',
          rowType: 'hb0'
        },
        {
          label: 'BREAKTHROUGH',
          rowType: 'h0'
        },
        {
          metric: 111,
          label: 'Branded Recall',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'IMPACT',
          rowType: 'h0'
        },
        {
          metric: 122,
          label: 'Lift to Impression',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 121,
          label: 'Lift to Consideration',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 123,
          label: 'Manufacturer Lift to Consider (T2B)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 124,
          label: 'Manufacturer Lift to Consider (Neutral)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 125,
          label: 'Manufacturer Lift to Consider (B2B)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 126,
          label: 'Manufacturer Lift to Consider (Not Familiar)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 127,
          label: 'Net Actions',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 128,
          label: "Ask doctor/HCP if brand is good treatment option",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 129,
          label: "Talk to doctor/HCP about this condition",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 130,
          label: "Visit this brand’s website for more info",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 131,
          label: "Call/email this brand for more info",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 132,
          label: "Take advantage of an offer or promotion",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 133,
          label: "Discuss the brand with friends or relatives",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 134,
          label: "Search online for more info about the brand",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 135,
          label: "Follow the brand on social media",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'CREATIVE DIAGNOSTICS',
          rowType: 'hb0'
        },
        {
          label: 'BRANDING',
          rowType: 'h0'
        },
        {
          metric: 136,
          label: 'Manufacturer Recognition',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 138,
          label: 'Ease of Branding',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 139,
          label: 'Unique to this Brand',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          label: 'APPEAL',
          rowType: 'h0'
        },
        {
          metric: 202,
          label: 'Likes',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 203,
          label: 'Dislikes',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: true
        },
        {
          label: 'CREATIVE EFFICIENCY',
          rowType: 'h0'
        },
        {
          metric: 204,
          label: 'Category Drivers',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 140,
          label: 'Shows a product that would fit with my routine',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 141,
          label: 'Shows how I would benefit from this product',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 142,
          label: 'Features a product that will improve my quality of life',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 143,
          label: 'Features a product that will make my life easier',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 144,
          label: 'Brand Connection',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 145,
          label: 'Shows a treatment that could help me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 146,
          label: 'Portrays a brand that I can trust',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },

        {
          metric: 147,
          label: 'Portrays a brand that fulfills my needs',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 148,
          label: 'Relevance',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 149,
          label: 'Spoke directly to me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 150,
          label: 'Relatable people, scenes and/or activities',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 151,
          label: 'Is worth seeing again',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 152,
          label: 'Comforting',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 153,
          label: 'Engagement Emotion',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 154,
          label: 'Unique',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },

        {
          metric: 155,
          label: 'Clever',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 156,
          label: 'Worth talking about',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 157,
          label: 'Grabs my attention from the start',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 158,
          label: 'Makes me feel hopeful',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 159,
          label: 'Annoying',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 160,
          label: 'Boring',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 161,
          label: 'Cognitive Connection',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 162,
          label: 'Informative',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 163,
          label: "Contains the appropriate amount of information",
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 164,
          label: 'Has visuals that make sense to me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 165,
          label: 'Clear',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 166,
          label: 'Tells me something new',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 167,
          label: 'Believable',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 168,
          label: 'Has a clean look and feel',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 169,
          label: 'Raises side effects that concern me',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 170,
          label: 'Confusing',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          label: 'ATTENTION',
          rowType: 'h0'
        },
        {
          label: 'Strength of Ad Engagement TV',
          rowType: 'h0'
        },
        {
          metric: 171,
          label: 'Strength of Ad Engagement (T2B)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 172,
          label: 'Ignore the ad/not notice the ad at all',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 173,
          label: 'Notice the ad, but not pay much attention to it',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 174,
          label: 'Pause briefly to watch the ad',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 175,
          label: 'Watch the entire ad',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'MESSAGING',
          rowType: 'h0'
        },
        {
          label: 'Most Motivating Message (Cibinqo) ',
          rowType: 'h0'
        },
        {
          metric: 193,
          label: 'Cibinqo can help you get out in front of eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 194,
          label: `Continuously treats eczema, whether you're flaring or not`,
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 195,
          label: 'Treatment for moderate-to-severe eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 196,
          label: '100% steroid free',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 197,
          label: 'Not an injection',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 198,
          label: 'Cibinqo is a once daily pill',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 199,
          label: 'Proven to provide clearer skin and relieve itch fast',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 200,
          label: `For adults who didn't respond to previous treatment`,
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 201,
          label: 'Ask your doctor about prescription Cibinqo',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 205,
          label: 'For people ages 12 and over',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 232,
          label: 'Helps reduce itch fast',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 233,
          label: 'Once daily Cibinqo fights eczema day and night',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'Most Motivating Message (Dupixent) ',
          rowType: 'h0'
        },
        {
          metric: 206,
          label: 'Helps heal your skin from within',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 207,
          label: 'With less eczema, you can show more skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 208,
          label: 'First treatment of its kind',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 209,
          label: 'Continually treats eczema/AD, even between flare ups',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 210,
          label: 'Not a cream or steroid',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 211,
          label: 'Significantly less itch',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 212,
          label: 'Significant reduction in itch',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 213,
          label: 'Difference you can feel',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 214,
          label: 'Allows me to outsmart eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 215,
          label: 'Works for kids and adults',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 216,
          label: 'Gets eczema under control ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 217,
          label: 'Long lasting clearer skin ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 218,
          label: 'Fast itch relief after first dose',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 219,
          label: 'Hits eczema where it counts ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 220,
          label: 'Keeps you one step ahead of eczema ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 221,
          label: 'Changes how skin looks and feels ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 222,
          label: 'Real world results',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 234,
          label: 'Shows off clearer skin, shows off less itch',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 235,
          label: 'FDA-Approved for ages 6 months and up',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 236,
          label: '#1 prescribed biologic by dermatologists & allergists',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 237,
          label: 'Blocks a key source of inflammation inside the body',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 238,
          label: 'With Dupixent, you can stay ahead of your eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'Most Motivating Message (Rinvoq) ',
          rowType: 'h0'
        },
        {
          metric: 223,
          label: 'Rinvoq is not a steroid, topical, injection',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 224,
          label: 'One pill, once a day',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 225,
          label: 'Effective without taking topical steroids',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 226,
          label: '75% clearer skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 227,
          label: 'Up to 100% clearer skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 228,
          label: 'Fast Itch Relief, in as early as 1 week',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 229,
          label: 'Allows you to be your high performing self',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 230,
          label: 'Disrupt the itch and rash of eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 231,
          label: 'Talk to your doctor about Rinvoq',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 239,
          label: 'Rinvoq is a once daily pill',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 240,
          label: 'Many taking Rinvoq saw clear/almost clear skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 241,
          label: 'Dramatic skin clearance as early as 2 weeks',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 242,
          label: 'Significant itch relief, in as early as 2 days',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 243,
          label: 'Help heal your painful skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 244,
          label: 'Reduces the itch and helps clear the rash fast',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 245,
          label: 'Finding the right eczema treatment, starts with finding the right doctor',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 246,
          label: 'Use our tool to find an expert near you',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 247,
          label: 'For moderate to severe eczema (atopic dermatitis) for patients 12+ years',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 248,
          label: 'Real eczema fighters sharing their Rinvoq stories',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 249,
          label: '75% skin clearance as early as 2 weeks',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: '',
          rowType: 'eol'
        }
      ]
    }
  },
  'online_video': {
    '***': {
      '***': [
        {
          metric: 100,
          inHeader: true,
          label: 'Ad Effect Score',
          rowType: 'demphasized',
          dataFormat: '.,0',
          reverseStat: false,
          minSampleSize: 0
        },
        {
          label: 'IN-MARKET PERFORMANCE',
          rowType: 'hb0'
        },
        {
          label: 'BREAKTHROUGH',
          rowType: 'h0'
        },
        {
          metric: 111,
          label: 'Branded Recall',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'IMPACT',
          rowType: 'h0'
        },
        {
          metric: 122,
          label: 'Lift to Impression',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 121,
          label: 'Lift to Consideration',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 123,
          label: 'Manufacturer Lift to Consider (T2B)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 124,
          label: 'Manufacturer Lift to Consider (Neutral)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 125,
          label: 'Manufacturer Lift to Consider (B2B)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 126,
          label: 'Manufacturer Lift to Consider (Not Familiar)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 127,
          label: 'Net Actions',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 128,
          label: "Ask doctor/HCP if brand is good treatment option",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 129,
          label: "Talk to doctor/HCP about this condition",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 130,
          label: "Visit this brand’s website for more info",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 131,
          label: "Call/email this brand for more info",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 132,
          label: "Take advantage of an offer or promotion",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 133,
          label: "Discuss the brand with friends or relatives",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 134,
          label: "Search online for more info about the brand",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 135,
          label: "Follow the brand on social media",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'CREATIVE DIAGNOSTICS',
          rowType: 'hb0'
        },
        {
          label: 'BRANDING',
          rowType: 'h0'
        },
        {
          metric: 136,
          label: 'Manufacturer Recognition',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 138,
          label: 'Ease of Branding',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 139,
          label: 'Unique to this Brand',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          label: 'APPEAL',
          rowType: 'h0'
        },
        {
          metric: 202,
          label: 'Likes',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 203,
          label: 'Dislikes',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: true
        },
        {
          label: 'CREATIVE EFFICIENCY',
          rowType: 'h0'
        },
        {
          metric: 204,
          label: 'Category Drivers',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 140,
          label: 'Shows a product that would fit with my routine',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 141,
          label: 'Shows how I would benefit from this product',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 142,
          label: 'Features a product that will improve my quality of life',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 143,
          label: 'Features a product that will make my life easier',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 144,
          label: 'Brand Connection',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 145,
          label: 'Shows a treatment that could help me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 146,
          label: 'Portrays a brand that I can trust',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },

        {
          metric: 147,
          label: 'Portrays a brand that fulfills my needs',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 148,
          label: 'Relevance',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 149,
          label: 'Spoke directly to me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 150,
          label: 'Relatable people, scenes and/or activities',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 151,
          label: 'Is worth seeing again',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 152,
          label: 'Comforting',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 153,
          label: 'Engagement Emotion',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 154,
          label: 'Unique',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },

        {
          metric: 155,
          label: 'Clever',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 156,
          label: 'Worth talking about',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 157,
          label: 'Grabs my attention from the start',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 158,
          label: 'Makes me feel hopeful',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 159,
          label: 'Annoying',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 160,
          label: 'Boring',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 161,
          label: 'Cognitive Connection',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 162,
          label: 'Informative',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 163,
          label: "Contains the appropriate amount of information",
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 164,
          label: 'Has visuals that make sense to me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 165,
          label: 'Clear',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 166,
          label: 'Tells me something new',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 167,
          label: 'Believable',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 168,
          label: 'Has a clean look and feel',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 169,
          label: 'Raises side effects that concern me',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 170,
          label: 'Confusing',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          label: 'ATTENTION',
          rowType: 'h0'
        },
        {
          label: 'Strength of Ad Engagement Online Display/OLV',
          rowType: 'h0'
        },
        {
          metric: 182,
          label: 'Strength of Ad Engagement (T2B)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 183,
          label: 'Ignore the ad/not notice the ad at all',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 184,
          label: 'Notice the ad, dismiss it as annoying/not relevant to me',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 185,
          label: 'Pause briefly to look at the ad',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 186,
          label: 'Watch or read the entire ad, but not click on it',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 187,
          label: 'Click on the ad',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'MESSAGING',
          rowType: 'h0'
        },
        {
          label: 'Most Motivating Message (Cibinqo) ',
          rowType: 'h0'
        },
        {
          metric: 193,
          label: 'Cibinqo can help you get out in front of eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 194,
          label: `Continuously treats eczema, whether you're flaring or not`,
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 195,
          label: 'Treatment for moderate-to-severe eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 196,
          label: '100% steroid free',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 197,
          label: 'Not an injection',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 198,
          label: 'Cibinqo is a once daily pill',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 199,
          label: 'Proven to provide clearer skin and relieve itch fast',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 200,
          label: `For adults who didn't respond to previous treatment`,
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 201,
          label: 'Ask your doctor about prescription Cibinqo',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 205,
          label: 'For people ages 12 and over',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 232,
          label: 'Helps reduce itch fast',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 233,
          label: 'Once daily Cibinqo fights eczema day and night',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'Most Motivating Message (Dupixent) ',
          rowType: 'h0'
        },
        {
          metric: 206,
          label: 'Helps heal your skin from within',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 207,
          label: 'With less eczema, you can show more skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 208,
          label: 'First treatment of its kind',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 209,
          label: 'Continually treats eczema/AD, even between flare ups',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 210,
          label: 'Not a cream or steroid',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 211,
          label: 'Significantly less itch',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 212,
          label: 'Significant reduction in itch',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 213,
          label: 'Difference you can feel',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 214,
          label: 'Allows me to outsmart eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 215,
          label: 'Works for kids and adults',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 216,
          label: 'Gets eczema under control ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 217,
          label: 'Long lasting clearer skin ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 218,
          label: 'Fast itch relief after first dose',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 219,
          label: 'Hits eczema where it counts ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 220,
          label: 'Keeps you one step ahead of eczema ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 221,
          label: 'Changes how skin looks and feels ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 222,
          label: 'Real world results',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 234,
          label: 'Shows off clearer skin, shows off less itch',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 235,
          label: 'FDA-Approved for ages 6 months and up',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 236,
          label: '#1 prescribed biologic by dermatologists & allergists',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 237,
          label: 'Blocks a key source of inflammation inside the body',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 238,
          label: 'With Dupixent, you can stay ahead of your eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'Most Motivating Message (Rinvoq) ',
          rowType: 'h0'
        },
        {
          metric: 223,
          label: 'Rinvoq is not a steroid, topical, injection',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 224,
          label: 'One pill, once a day',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 225,
          label: 'Effective without taking topical steroids',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 226,
          label: '75% clearer skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 227,
          label: 'Up to 100% clearer skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 228,
          label: 'Fast Itch Relief, in as early as 1 week',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 229,
          label: 'Allows you to be your high performing self',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 230,
          label: 'Disrupt the itch and rash of eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 231,
          label: 'Talk to your doctor about Rinvoq',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 239,
          label: 'Rinvoq is a once daily pill',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 240,
          label: 'Many taking Rinvoq saw clear/almost clear skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 241,
          label: 'Dramatic skin clearance as early as 2 weeks',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 242,
          label: 'Significant itch relief, in as early as 2 days',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 243,
          label: 'Help heal your painful skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 244,
          label: 'Reduces the itch and helps clear the rash fast',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 245,
          label: 'Finding the right eczema treatment, starts with finding the right doctor',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 246,
          label: 'Use our tool to find an expert near you',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 247,
          label: 'For moderate to severe eczema (atopic dermatitis) for patients 12+ years',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 248,
          label: 'Real eczema fighters sharing their Rinvoq stories',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 249,
          label: '75% skin clearance as early as 2 weeks',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: '',
          rowType: 'eol'
        }
      ]
    }
  },
  'social_media': {
    '***': {
      '***': [
        {
          metric: 100,
          inHeader: true,
          label: 'Ad Effect Score',
          rowType: 'demphasized',
          dataFormat: '.,0',
          reverseStat: false,
          minSampleSize: 0
        },
        {
          label: 'IN-MARKET PERFORMANCE',
          rowType: 'hb0'
        },
        {
          label: 'BREAKTHROUGH',
          rowType: 'h0'
        },
        {
          metric: 111,
          label: 'Branded Recall',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'IMPACT',
          rowType: 'h0'
        },
        {
          metric: 122,
          label: 'Lift to Impression',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 121,
          label: 'Lift to Consideration',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 123,
          label: 'Manufacturer Lift to Consider (T2B)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 124,
          label: 'Manufacturer Lift to Consider (Neutral)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 125,
          label: 'Manufacturer Lift to Consider (B2B)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 126,
          label: 'Manufacturer Lift to Consider (Not Familiar)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 127,
          label: 'Net Actions',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 128,
          label: "Ask doctor/HCP if brand is good treatment option",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 129,
          label: "Talk to doctor/HCP about this condition",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 130,
          label: "Visit this brand’s website for more info",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 131,
          label: "Call/email this brand for more info",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 132,
          label: "Take advantage of an offer or promotion",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 133,
          label: "Discuss the brand with friends or relatives",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 134,
          label: "Search online for more info about the brand",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 135,
          label: "Follow the brand on social media",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'CREATIVE DIAGNOSTICS',
          rowType: 'hb0'
        },
        {
          label: 'BRANDING',
          rowType: 'h0'
        },
        {
          metric: 136,
          label: 'Manufacturer Recognition',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 138,
          label: 'Ease of Branding',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 139,
          label: 'Unique to this Brand',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          label: 'APPEAL',
          rowType: 'h0'
        },
        {
          metric: 202,
          label: 'Likes',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 203,
          label: 'Dislikes',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: true
        },
        {
          label: 'CREATIVE EFFICIENCY',
          rowType: 'h0'
        },
        {
          metric: 204,
          label: 'Category Drivers',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 140,
          label: 'Shows a product that would fit with my routine',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 141,
          label: 'Shows how I would benefit from this product',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 142,
          label: 'Features a product that will improve my quality of life',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 143,
          label: 'Features a product that will make my life easier',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 144,
          label: 'Brand Connection',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 145,
          label: 'Shows a treatment that could help me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 146,
          label: 'Portrays a brand that I can trust',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },

        {
          metric: 147,
          label: 'Portrays a brand that fulfills my needs',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 148,
          label: 'Relevance',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 149,
          label: 'Spoke directly to me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 150,
          label: 'Relatable people, scenes and/or activities',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 151,
          label: 'Is worth seeing again',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 152,
          label: 'Comforting',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 153,
          label: 'Engagement Emotion',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 154,
          label: 'Unique',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },

        {
          metric: 155,
          label: 'Clever',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 156,
          label: 'Worth talking about',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 157,
          label: 'Grabs my attention from the start',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 158,
          label: 'Makes me feel hopeful',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 159,
          label: 'Annoying',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 160,
          label: 'Boring',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 161,
          label: 'Cognitive Connection',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 162,
          label: 'Informative',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 163,
          label: "Contains the appropriate amount of information",
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 164,
          label: 'Has visuals that make sense to me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 165,
          label: 'Clear',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 166,
          label: 'Tells me something new',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 167,
          label: 'Believable',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 168,
          label: 'Has a clean look and feel',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 169,
          label: 'Raises side effects that concern me',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 170,
          label: 'Confusing',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          label: 'ATTENTION',
          rowType: 'h0'
        },
        {
          label: 'Strength of Ad Engagement Social Media',
          rowType: 'h0'
        },
        {
          metric: 176,
          label: 'Strength of Ad Engagement (T3B)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 177,
          label: 'Ignore /not notice at all in my news feed',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 178,
          label: 'Notice, dismiss it as annoying/not relevant to me',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 179,
          label: 'Pause briefly to look',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },

        {
          metric: 180,
          label: 'Look at the ad closely, but would not want to learn more',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 181,
          label: 'Look at the ad closely and would visit the website to learn more',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'MESSAGING',
          rowType: 'h0'
        },
        {
          label: 'Most Motivating Message (Cibinqo) ',
          rowType: 'h0'
        },
        {
          metric: 193,
          label: 'Cibinqo can help you get out in front of eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 194,
          label: `Continuously treats eczema, whether you're flaring or not`,
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 195,
          label: 'Treatment for moderate-to-severe eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 196,
          label: '100% steroid free',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 197,
          label: 'Not an injection',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 198,
          label: 'Cibinqo is a once daily pill',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 199,
          label: 'Proven to provide clearer skin and relieve itch fast',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 200,
          label: `For adults who didn't respond to previous treatment`,
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 201,
          label: 'Ask your doctor about prescription Cibinqo',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 205,
          label: 'For people ages 12 and over',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 232,
          label: 'Helps reduce itch fast',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 233,
          label: 'Once daily Cibinqo fights eczema day and night',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'Most Motivating Message (Dupixent) ',
          rowType: 'h0'
        },
        {
          metric: 206,
          label: 'Helps heal your skin from within',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 207,
          label: 'With less eczema, you can show more skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 208,
          label: 'First treatment of its kind',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 209,
          label: 'Continually treats eczema/AD, even between flare ups',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 210,
          label: 'Not a cream or steroid',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 211,
          label: 'Significantly less itch',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 212,
          label: 'Significant reduction in itch',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 213,
          label: 'Difference you can feel',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 214,
          label: 'Allows me to outsmart eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 215,
          label: 'Works for kids and adults',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 216,
          label: 'Gets eczema under control ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 217,
          label: 'Long lasting clearer skin ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 218,
          label: 'Fast itch relief after first dose',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 219,
          label: 'Hits eczema where it counts ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 220,
          label: 'Keeps you one step ahead of eczema ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 221,
          label: 'Changes how skin looks and feels ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 222,
          label: 'Real world results',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 234,
          label: 'Shows off clearer skin, shows off less itch',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 235,
          label: 'FDA-Approved for ages 6 months and up',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 236,
          label: '#1 prescribed biologic by dermatologists & allergists',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 237,
          label: 'Blocks a key source of inflammation inside the body',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 238,
          label: 'With Dupixent, you can stay ahead of your eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'Most Motivating Message (Rinvoq) ',
          rowType: 'h0'
        },
        {
          metric: 223,
          label: 'Rinvoq is not a steroid, topical, injection',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 224,
          label: 'One pill, once a day',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 225,
          label: 'Effective without taking topical steroids',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 226,
          label: '75% clearer skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 227,
          label: 'Up to 100% clearer skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 228,
          label: 'Fast Itch Relief, in as early as 1 week',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 229,
          label: 'Allows you to be your high performing self',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 230,
          label: 'Disrupt the itch and rash of eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 231,
          label: 'Talk to your doctor about Rinvoq',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 239,
          label: 'Rinvoq is a once daily pill',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 240,
          label: 'Many taking Rinvoq saw clear/almost clear skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 241,
          label: 'Dramatic skin clearance as early as 2 weeks',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 242,
          label: 'Significant itch relief, in as early as 2 days',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 243,
          label: 'Help heal your painful skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 244,
          label: 'Reduces the itch and helps clear the rash fast',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 245,
          label: 'Finding the right eczema treatment, starts with finding the right doctor',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 246,
          label: 'Use our tool to find an expert near you',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 247,
          label: 'For moderate to severe eczema (atopic dermatitis) for patients 12+ years',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 248,
          label: 'Real eczema fighters sharing their Rinvoq stories',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 249,
          label: '75% skin clearance as early as 2 weeks',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: '',
          rowType: 'eol'
        }
      ]
    }
  },
  'online_display': {
    '***': {
      '***': [
        {
          metric: 100,
          inHeader: true,
          label: 'Ad Effect Score',
          rowType: 'demphasized',
          dataFormat: '.,0',
          reverseStat: false,
          minSampleSize: 0
        },
        {
          label: 'IN-MARKET PERFORMANCE',
          rowType: 'hb0'
        },
        {
          label: 'BREAKTHROUGH',
          rowType: 'h0'
        },
        {
          metric: 111,
          label: 'Branded Recall',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'IMPACT',
          rowType: 'h0'
        },
        {
          metric: 122,
          label: 'Lift to Impression',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 121,
          label: 'Lift to Consideration',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 123,
          label: 'Manufacturer Lift to Consider (T2B)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 124,
          label: 'Manufacturer Lift to Consider (Neutral)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 125,
          label: 'Manufacturer Lift to Consider (B2B)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 126,
          label: 'Manufacturer Lift to Consider (Not Familiar)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 127,
          label: 'Net Actions',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 128,
          label: "Ask doctor/HCP if brand is good treatment option",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 129,
          label: "Talk to doctor/HCP about this condition",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 130,
          label: "Visit this brand’s website for more info",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 131,
          label: "Call/email this brand for more info",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 132,
          label: "Take advantage of an offer or promotion",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 133,
          label: "Discuss the brand with friends or relatives",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 134,
          label: "Search online for more info about the brand",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 135,
          label: "Follow the brand on social media",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'CREATIVE DIAGNOSTICS',
          rowType: 'hb0'
        },
        {
          label: 'BRANDING',
          rowType: 'h0'
        },
        {
          metric: 136,
          label: 'Manufacturer Recognition',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 138,
          label: 'Ease of Branding',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 139,
          label: 'Unique to this Brand',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          label: 'APPEAL',
          rowType: 'h0'
        },
        {
          metric: 202,
          label: 'Likes',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 203,
          label: 'Dislikes',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: true
        },
        {
          label: 'CREATIVE EFFICIENCY',
          rowType: 'h0'
        },
        {
          metric: 204,
          label: 'Category Drivers',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 140,
          label: 'Shows a product that would fit with my routine',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 141,
          label: 'Shows how I would benefit from this product',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 142,
          label: 'Features a product that will improve my quality of life',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 143,
          label: 'Features a product that will make my life easier',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 144,
          label: 'Brand Connection',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 145,
          label: 'Shows a treatment that could help me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 146,
          label: 'Portrays a brand that I can trust',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },

        {
          metric: 147,
          label: 'Portrays a brand that fulfills my needs',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 148,
          label: 'Relevance',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 149,
          label: 'Spoke directly to me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 150,
          label: 'Relatable people, scenes and/or activities',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 151,
          label: 'Is worth seeing again',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 152,
          label: 'Comforting',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 153,
          label: 'Engagement Emotion',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 154,
          label: 'Unique',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },

        {
          metric: 155,
          label: 'Clever',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 156,
          label: 'Worth talking about',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 157,
          label: 'Grabs my attention from the start',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 158,
          label: 'Makes me feel hopeful',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 159,
          label: 'Annoying',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 160,
          label: 'Boring',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 161,
          label: 'Cognitive Connection',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 162,
          label: 'Informative',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 163,
          label: "Contains the appropriate amount of information",
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 164,
          label: 'Has visuals that make sense to me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 165,
          label: 'Clear',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 166,
          label: 'Tells me something new',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 167,
          label: 'Believable',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 168,
          label: 'Has a clean look and feel',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 169,
          label: 'Raises side effects that concern me',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 170,
          label: 'Confusing',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          label: 'ATTENTION',
          rowType: 'h0'
        },
        {
          label: 'Strength of Ad Engagement Online Display/OLV',
          rowType: 'h0'
        },
        {
          metric: 182,
          label: 'Strength of Ad Engagement (T2B)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 183,
          label: 'Ignore the ad/not notice the ad at all',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 184,
          label: 'Notice the ad, dismiss it as annoying/not relevant to me',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 185,
          label: 'Pause briefly to look at the ad',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 186,
          label: 'Watch or read the entire ad, but not click on it',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 187,
          label: 'Click on the ad',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'MESSAGING',
          rowType: 'h0'
        },
        {
          label: 'Most Motivating Message (Cibinqo) ',
          rowType: 'h0'
        },
        {
          metric: 193,
          label: 'Cibinqo can help you get out in front of eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 194,
          label: `Continuously treats eczema, whether you're flaring or not`,
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 195,
          label: 'Treatment for moderate-to-severe eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 196,
          label: '100% steroid free',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 197,
          label: 'Not an injection',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 198,
          label: 'Cibinqo is a once daily pill',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 199,
          label: 'Proven to provide clearer skin and relieve itch fast',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 200,
          label: `For adults who didn't respond to previous treatment`,
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 201,
          label: 'Ask your doctor about prescription Cibinqo',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 205,
          label: 'For people ages 12 and over',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 232,
          label: 'Helps reduce itch fast',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 233,
          label: 'Once daily Cibinqo fights eczema day and night',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'Most Motivating Message (Dupixent) ',
          rowType: 'h0'
        },
        {
          metric: 206,
          label: 'Helps heal your skin from within',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 207,
          label: 'With less eczema, you can show more skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 208,
          label: 'First treatment of its kind',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 209,
          label: 'Continually treats eczema/AD, even between flare ups',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 210,
          label: 'Not a cream or steroid',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 211,
          label: 'Significantly less itch',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 212,
          label: 'Significant reduction in itch',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 213,
          label: 'Difference you can feel',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 214,
          label: 'Allows me to outsmart eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 215,
          label: 'Works for kids and adults',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 216,
          label: 'Gets eczema under control ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 217,
          label: 'Long lasting clearer skin ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 218,
          label: 'Fast itch relief after first dose',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 219,
          label: 'Hits eczema where it counts ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 220,
          label: 'Keeps you one step ahead of eczema ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 221,
          label: 'Changes how skin looks and feels ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 222,
          label: 'Real world results',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 234,
          label: 'Shows off clearer skin, shows off less itch',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 235,
          label: 'FDA-Approved for ages 6 months and up',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 236,
          label: '#1 prescribed biologic by dermatologists & allergists',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 237,
          label: 'Blocks a key source of inflammation inside the body',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 238,
          label: 'With Dupixent, you can stay ahead of your eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'Most Motivating Message (Rinvoq) ',
          rowType: 'h0'
        },
        {
          metric: 223,
          label: 'Rinvoq is not a steroid, topical, injection',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 224,
          label: 'One pill, once a day',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 225,
          label: 'Effective without taking topical steroids',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 226,
          label: '75% clearer skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 227,
          label: 'Up to 100% clearer skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 228,
          label: 'Fast Itch Relief, in as early as 1 week',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 229,
          label: 'Allows you to be your high performing self',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 230,
          label: 'Disrupt the itch and rash of eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 231,
          label: 'Talk to your doctor about Rinvoq',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 239,
          label: 'Rinvoq is a once daily pill',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 240,
          label: 'Many taking Rinvoq saw clear/almost clear skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 241,
          label: 'Dramatic skin clearance as early as 2 weeks',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 242,
          label: 'Significant itch relief, in as early as 2 days',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 243,
          label: 'Help heal your painful skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 244,
          label: 'Reduces the itch and helps clear the rash fast',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 245,
          label: 'Finding the right eczema treatment, starts with finding the right doctor',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 246,
          label: 'Use our tool to find an expert near you',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 247,
          label: 'For moderate to severe eczema (atopic dermatitis) for patients 12+ years',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 248,
          label: 'Real eczema fighters sharing their Rinvoq stories',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 249,
          label: '75% skin clearance as early as 2 weeks',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: '',
          rowType: 'eol'
        }
      ]
    }
  },
  'print': {
    '***': {
      '***': [
        {
          metric: 100,
          inHeader: true,
          label: 'Ad Effect Score',
          rowType: 'demphasized',
          dataFormat: '.,0',
          reverseStat: false,
          minSampleSize: 0
        },
        {
          label: 'IN-MARKET PERFORMANCE',
          rowType: 'hb0'
        },
        {
          label: 'BREAKTHROUGH',
          rowType: 'h0'
        },
        {
          metric: 111,
          label: 'Branded Recall',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'IMPACT',
          rowType: 'h0'
        },
        {
          metric: 122,
          label: 'Lift to Impression',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 121,
          label: 'Lift to Consideration',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 123,
          label: 'Manufacturer Lift to Consider (T2B)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 124,
          label: 'Manufacturer Lift to Consider (Neutral)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 125,
          label: 'Manufacturer Lift to Consider (B2B)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 126,
          label: 'Manufacturer Lift to Consider (Not Familiar)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 127,
          label: 'Net Actions',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 128,
          label: "Ask doctor/HCP if brand is good treatment option",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 129,
          label: "Talk to doctor/HCP about this condition",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 130,
          label: "Visit this brand’s website for more info",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 131,
          label: "Call/email this brand for more info",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 132,
          label: "Take advantage of an offer or promotion",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 133,
          label: "Discuss the brand with friends or relatives",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 134,
          label: "Search online for more info about the brand",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 135,
          label: "Follow the brand on social media",
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'CREATIVE DIAGNOSTICS',
          rowType: 'hb0'
        },
        {
          label: 'BRANDING',
          rowType: 'h0'
        },
        {
          metric: 136,
          label: 'Manufacturer Recognition',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 138,
          label: 'Ease of Branding',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 139,
          label: 'Unique to this Brand',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          label: 'APPEAL',
          rowType: 'h0'
        },
        {
          metric: 202,
          label: 'Likes',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 203,
          label: 'Dislikes',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: true
        },
        {
          label: 'CREATIVE EFFICIENCY',
          rowType: 'h0'
        },
        {
          metric: 204,
          label: 'Category Drivers',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 140,
          label: 'Shows a product that would fit with my routine',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 141,
          label: 'Shows how I would benefit from this product',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 142,
          label: 'Features a product that will improve my quality of life',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 143,
          label: 'Features a product that will make my life easier',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 144,
          label: 'Brand Connection',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 145,
          label: 'Shows a treatment that could help me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 146,
          label: 'Portrays a brand that I can trust',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },

        {
          metric: 147,
          label: 'Portrays a brand that fulfills my needs',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 148,
          label: 'Relevance',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 149,
          label: 'Spoke directly to me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 150,
          label: 'Relatable people, scenes and/or activities',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 151,
          label: 'Is worth seeing again',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 152,
          label: 'Comforting',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 153,
          label: 'Engagement Emotion',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 154,
          label: 'Unique',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },

        {
          metric: 155,
          label: 'Clever',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 156,
          label: 'Worth talking about',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 157,
          label: 'Grabs my attention from the start',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 158,
          label: 'Makes me feel hopeful',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 159,
          label: 'Annoying',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 160,
          label: 'Boring',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 161,
          label: 'Cognitive Connection',
          rowType: 'dh0',
          dataFormat: 'idxd',
          reverseStat: false
        },
        {
          metric: 162,
          label: 'Informative',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 163,
          label: "Contains the appropriate amount of information",
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 164,
          label: 'Has visuals that make sense to me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 165,
          label: 'Clear',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 166,
          label: 'Tells me something new',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 167,
          label: 'Believable',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 168,
          label: 'Has a clean look and feel',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 169,
          label: 'Raises side effects that concern me',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 170,
          label: 'Confusing',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          label: 'ATTENTION',
          rowType: 'h0'
        },
        {
          label: 'Strength of Ad Engagement Print',
          rowType: 'h0'
        },
        {
          metric: 188,
          label: 'Strength of Ad Engagement (T2B)',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 189,
          label: 'Ignore the ad/not notice the ad at all',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 190,
          label: 'Notice the ad, but not pay much attention to it',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 191,
          label: `Pause briefly to look at the ad`,
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 192,
          label: `Read the entire ad in detail`,
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'MESSAGING',
          rowType: 'h0'
        },
        {
          label: 'Most Motivating Message (Cibinqo) ',
          rowType: 'h0'
        },
        {
          metric: 193,
          label: 'Cibinqo can help you get out in front of eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 194,
          label: `Continuously treats eczema, whether you're flaring or not`,
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 195,
          label: 'Treatment for moderate-to-severe eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 196,
          label: '100% steroid free',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 197,
          label: 'Not an injection',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 198,
          label: 'Cibinqo is a once daily pill',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 199,
          label: 'Proven to provide clearer skin and relieve itch fast',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 200,
          label: `For adults who didn't respond to previous treatment`,
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 201,
          label: 'Ask your doctor about prescription Cibinqo',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 205,
          label: 'For people ages 12 and over',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 232,
          label: 'Helps reduce itch fast',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 233,
          label: 'Once daily Cibinqo fights eczema day and night',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'Most Motivating Message (Dupixent) ',
          rowType: 'h0'
        },
        {
          metric: 206,
          label: 'Helps heal your skin from within',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 207,
          label: 'With less eczema, you can show more skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 208,
          label: 'First treatment of its kind',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 209,
          label: 'Continually treats eczema/AD, even between flare ups',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 210,
          label: 'Not a cream or steroid',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 211,
          label: 'Significantly less itch',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 212,
          label: 'Significant reduction in itch',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 213,
          label: 'Difference you can feel',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 214,
          label: 'Allows me to outsmart eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 215,
          label: 'Works for kids and adults',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 216,
          label: 'Gets eczema under control ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 217,
          label: 'Long lasting clearer skin ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 218,
          label: 'Fast itch relief after first dose',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 219,
          label: 'Hits eczema where it counts ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 220,
          label: 'Keeps you one step ahead of eczema ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 221,
          label: 'Changes how skin looks and feels ',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 222,
          label: 'Real world results',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 234,
          label: 'Shows off clearer skin, shows off less itch',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 235,
          label: 'FDA-Approved for ages 6 months and up',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 236,
          label: '#1 prescribed biologic by dermatologists & allergists',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 237,
          label: 'Blocks a key source of inflammation inside the body',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 238,
          label: 'With Dupixent, you can stay ahead of your eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'Most Motivating Message (Rinvoq) ',
          rowType: 'h0'
        },
        {
          metric: 223,
          label: 'Rinvoq is not a steroid, topical, injection',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 224,
          label: 'One pill, once a day',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 225,
          label: 'Effective without taking topical steroids',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 226,
          label: '75% clearer skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 227,
          label: 'Up to 100% clearer skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 228,
          label: 'Fast Itch Relief, in as early as 1 week',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 229,
          label: 'Allows you to be your high performing self',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 230,
          label: 'Disrupt the itch and rash of eczema',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 231,
          label: 'Talk to your doctor about Rinvoq',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 239,
          label: 'Rinvoq is a once daily pill',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 240,
          label: 'Many taking Rinvoq saw clear/almost clear skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 241,
          label: 'Dramatic skin clearance as early as 2 weeks',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 242,
          label: 'Significant itch relief, in as early as 2 days',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 243,
          label: 'Help heal your painful skin',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 244,
          label: 'Reduces the itch and helps clear the rash fast',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 245,
          label: 'Finding the right eczema treatment, starts with finding the right doctor',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 246,
          label: 'Use our tool to find an expert near you',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 247,
          label: 'For moderate to severe eczema (atopic dermatitis) for patients 12+ years',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 248,
          label: 'Real eczema fighters sharing their Rinvoq stories',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 249,
          label: '75% skin clearance as early as 2 weeks',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: '',
          rowType: 'eol'
        }
      ]
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/configuration/Pfizer/config/components/scorecard/MetricsLabels/metricsLabels.js